import { render, staticRenderFns } from "./punchStatisticsddetails.vue?vue&type=template&id=2f2996fe"
import script from "./punchStatisticsddetails.vue?vue&type=script&lang=js"
export * from "./punchStatisticsddetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports